<template>
  <div class="section-white">
    <h2 class="profile_top-title">
      <i class="gd-borealia" />
      Borealia
    </h2>

    <p class="little-sub-text">
      Vous avez une turbine à glace et yaourtière Borealia® ? Renseignez le numéro de série de votre machine pour afficher le badge sur votre profil.
    </p>

    <div class="fields">
      <div class="six wide field">
        <label>Numéro de série</label>
        <input type="text" v-model="serial" placeholder="Numéro de série" />
      </div>

      <div
        v-if="touched"
        class="two wide field action-button"
      >
        <label>
          <button
            class="ui icon button custom-button custom-button--success"
            :disabled="saving"
            @click.prevent="save"
          >
            <i
              class="fa fa-fw"
              :class="saving ? 'fa-spinner fa-spin' : 'fa-check'"
            />
          </button>
        </label>
      </div>
    </div>

    <!-- <div class="ui divider custom-divider--profil m-t-2 m-b-2" />

    <div class="img-borealia">
      <div class="img-device-container__wrap">
        <i class="gdm-information" />
        <div class="borealia-info">Le numéro de série de votre be save est visible sur l'étiquette située sous votre robot.</div>
      </div>
      <div class="img-serial-container__wrap">
        <img
          alt=""
          :src="require('images/club/borealia_serial.webp')"
        >
      </div>
    </div> -->
  </div>
</template>

<script>
  export default {
    props: {
      borealiaSerial: {
        type: String,
        default: ""
      },
    },
    data() {
      return {
        serial: this.borealiaSerial,
        saving: false
      }
    },
    computed: {
      touched() {
        return this.serial !== this.borealiaSerial 
      }
    },
    methods: {
      save() {
        this.saving = true

        this.$http.put(`/profil/${this.slug}`, { user: { borealia_serial: this.serial }})
        .then( () => {
          this.saving = false
          this.$emit('update', this.serial)
          window.globalFlashMessage("success", "Modifications enregistrées")
        })
        .catch( () => {
          this.saving = false
          window.globalFlashMessage("error", "Impossible d'enregistrer les modifications")
        })
      }
    },
  }
</script>

<style lang="stylus" scoped>
.action-button
  display: flex
  align-items: flex-end
</style>
